var _defs, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIkonerYrkerSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#333;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ikoner") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "31.36 10.85 30.4 9.89 28 10.95 30.31 13.27 31.36 10.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "31.62 10.33 32.16 9.12 30.94 9.65 31.62 10.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.8,30.51a.39.39,0,0,0,0-.54.41.41,0,0,0-.28-.11.38.38,0,0,0-.27.65A.39.39,0,0,0,29.8,30.51Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "30.19 13.54 30.31 13.27 28 10.95 27.73 11.07 30.19 13.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.66,13.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.33,27.06h0l16-16L27.26,11a.27.27,0,0,1,0-.26L10.94,27.06A.27.27,0,0,1,11.33,27.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.82,30.33h0L12,32.16,9.11,29.28l1.83-1.83h0a.27.27,0,0,1,0-.39l-2,2a.24.24,0,0,0-.08.2.24.24,0,0,0,.08.19l2.88,2.88a.24.24,0,0,0,.19.08.27.27,0,0,0,.2-.08l2-2a.26.26,0,0,1-.18.07A.32.32,0,0,1,13.82,30.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.4,14l-.11,0-.08-.06-16,16h0a.27.27,0,0,1,0,.38L30.6,13.94l0-.07A.29.29,0,0,1,30.4,14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.63,11.11a.27.27,0,0,1-.3,0l-16,16,.19.19,16-16L30,13.75l-16,16,.2.2,16-16a.26.26,0,0,1-.06-.3l0-.1-2.47-2.47Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "11.99 31.77 9.5 29.28 11.13 27.64 10.94 27.45 9.11 29.28 11.99 32.16 13.82 30.33 13.63 30.13 11.99 31.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.15,21.82l-.39.39,7,7a1.56,1.56,0,0,1,0,2.21,1.57,1.57,0,0,1-2.2,0l-7-7-.39.39,7,7.05a2.11,2.11,0,0,0,3-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.47,18.47a.34.34,0,0,1,.36.08l1.67,1.67.39-.39-1.67-1.67a.89.89,0,0,0-.93-.21A4.2,4.2,0,0,1,9.76,17a4.6,4.6,0,0,1-1.28-4.08.33.33,0,0,1,.22-.25.34.34,0,0,1,.35.08l2,2.05a.89.89,0,0,0,1.25,0l1.73-1.73a.89.89,0,0,0,0-1.25L12,9.78A.34.34,0,0,1,12,9.43a.33.33,0,0,1,.25-.22,4.59,4.59,0,0,1,4.08,1.28A4.2,4.2,0,0,1,17.22,15a.89.89,0,0,0,.21.93l1.67,1.67.39-.39-1.67-1.67a.34.34,0,0,1-.08-.36,4.75,4.75,0,0,0-1.07-5.1A5.15,5.15,0,0,0,12.1,8.67a.85.85,0,0,0-.68.6.91.91,0,0,0,.22.9l2,2a.34.34,0,0,1,0,.48L12,14.42a.33.33,0,0,1-.47,0L9.44,12.37a.91.91,0,0,0-.9-.22.85.85,0,0,0-.6.68A5.15,5.15,0,0,0,9.37,17.4,4.75,4.75,0,0,0,14.47,18.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.33,26.94a.32.32,0,0,0,.2.08.27.27,0,0,0,.19-.08L27.31,14.35a.28.28,0,1,0-.39-.39L14.33,26.55A.29.29,0,0,0,14.33,26.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32.53,8.75a.58.58,0,0,0-.59-.13l-4.53,2a.23.23,0,0,0-.12.1l0,0a.29.29,0,0,1,.39,0L28,11l2.4-1.06,1,1-1.05,2.41.29.29a.28.28,0,0,1,.06.3l2-4.55A.59.59,0,0,0,32.53,8.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.65,13.86h0v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.6,13.55l-.29-.29-.12.28.21.21-.19.19.08.06.11,0a.29.29,0,0,0,.25-.15v0h0A.28.28,0,0,0,30.6,13.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.26,11l.07.09.19-.2.2.21L28,11l-.28-.28a.29.29,0,0,0-.39,0l0,0A.27.27,0,0,0,27.26,11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.21,13.94l.19-.19-.21-.21,0,.1A.26.26,0,0,0,30.21,13.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.63,11.11l.09,0-.2-.21-.19.2A.27.27,0,0,0,27.63,11.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.21,30.33h0l0,0A0,0,0,0,0,14.21,30.33Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "10.94 27.06 10.94 27.06 10.94 27.06 10.94 27.06"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 12.3,
    y: 26.93,
    width: 0.55,
    height: 3.52,
    transform: "translate(-16.61 17.3) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.21,29.94h0l-.39.39h0a.32.32,0,0,0,.2.08.26.26,0,0,0,.18-.07l0,0A.27.27,0,0,0,14.21,29.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.94,27.45h0l.39-.39h0a.27.27,0,0,0-.39,0h0A.27.27,0,0,0,10.94,27.45Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.64,
    y: 29.9,
    width: 0.55,
    height: 0.28,
    transform: "translate(-17.16 18.64) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 10.96,
    y: 27.21,
    width: 0.55,
    height: 0.28,
    transform: "translate(-16.05 15.95) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.19,30.9a.94.94,0,0,0,0-1.32,1,1,0,0,0-1.33,0,.91.91,0,0,0-.27.66.9.9,0,0,0,.27.66.92.92,0,0,0,.66.28A1,1,0,0,0,30.19,30.9Zm-1.05-.66a.38.38,0,0,1,.38-.38.41.41,0,0,1,.28.11.39.39,0,0,1,0,.54.39.39,0,0,1-.55,0A.39.39,0,0,1,29.14,30.24Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIkonerYrkerSmall);
export default __webpack_public_path__ + "static/media/Ikoner_Yrker_small.30b6e281594d38751bc6cd65dfb885b0.svg";
export { ForwardRef as ReactComponent };